var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.5 12.5H10.5C9.39543 12.5 8.5 13.3954 8.5 14.5V50.5C8.5 51.6046 9.39543 52.5 10.5 52.5H54.5C55.6046 52.5 56.5 51.6046 56.5 50.5V14.5C56.5 13.3954 55.6046 12.5 54.5 12.5Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.5 42.5L21.0858 29.9142C21.2715 29.7285 21.4919 29.5812 21.7346 29.4807C21.9772 29.3802 22.2373 29.3284 22.5 29.3284C22.7626 29.3284 23.0227 29.3802 23.2653 29.4807C23.508 29.5812 23.7285 29.7285 23.9142 29.9142L35.0858 41.0858C35.2715 41.2715 35.4919 41.4188 35.7346 41.5193C35.9772 41.6198 36.2373 41.6716 36.5 41.6716C36.7626 41.6716 37.0227 41.6198 37.2653 41.5193C37.508 41.4188 37.7285 41.2715 37.9142 41.0858L43.0858 35.9142C43.2715 35.7285 43.4919 35.5812 43.7346 35.4807C43.9772 35.3802 44.2373 35.3284 44.5 35.3284C44.7626 35.3284 45.0227 35.3802 45.2653 35.4807C45.508 35.5812 45.7285 35.7285 45.9142 35.9142L56.5 46.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.5 29.5C41.7091 29.5 43.5 27.7091 43.5 25.5C43.5 23.2909 41.7091 21.5 39.5 21.5C37.2909 21.5 35.5 23.2909 35.5 25.5C35.5 27.7091 37.2909 29.5 39.5 29.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.bb74a6fe49222273f2a814f68bceca6c.svg";
export { ForwardRef as ReactComponent };